<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also By Margery Allingham</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Blackkerchief Dick</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The White Cottage Mystery</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Crime at Black Dudley</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Mystery Mile</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Look to the Lady</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Police at the Funeral</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Sweet Danger</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death of a Ghost</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Flowers for the Judge</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Case of the Late Pig</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Dancers in Mourning</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Fashion in Shrouds</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Black Plumes</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Traitor’s Purse</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Dance of the Years</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Coroner’s Pidgin</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">More Work for the Undertaker</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Tiger in the Smoke</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Beckoning Lady</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Hide My Eyes</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The China Governess</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Mind Readers</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Cargo of Eagles</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Darings of the Red Rose</p>
</div>
</div>
<h3 class="section-title subhead">Novellas &amp; Short Stories</h3>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Mr. Campion: Criminologist</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Mr. Campion and Others</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Wanted: Someone Innocent</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Casebook of Mr Campion</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Deadly Duo</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">No Love Lost</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Allingham Casebook</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Allingham Minibus</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Return of Mr. Campion</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Room to Let: A Radio-Play</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Campion at Christmas</p>
</div>
</div>
<h3 class="section-title subhead">Non-Fiction</h3>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">The Oaken Heart: The Story of an English Village at War</p>
</div>
</div>
<h3 class="section-title subhead">As Maxwell March</h3>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Rogue’s Holiday</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Man of Dangerous Secrets</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Devil and Her Son</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobymargeryallingham.vue?19a8f817